import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as yup from "yup";
import "bootstrap/dist/css/bootstrap.min.css";

// ✅ Validation Schema
const validationSchema = yup.object().shape({
  firstName: yup.string().required("First name is required"),
  lastName: yup.string().required("Last name is required"),
  email: yup
    .string()
    .email("Invalid email format")
    .required("Email is required"),
  password: yup
    .string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
});

const SignUp = () => {
  const [message, setMessage] = useState({ text: "", type: "" });

  const handleSubmit = async (values, { setSubmitting }) => {
    setMessage({ text: "", type: "" });

    try {
      await new Promise((resolve) => setTimeout(resolve, 1500)); // Simulated API delay
      setMessage({ text: "Sign-up successful!", type: "success" });
    } catch (error) {
      setMessage({
        text: "Error during sign-up. Please try again.",
        type: "danger",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="container d-flex justify-content-center align-items-center "
      id="signup-container"
    >
      <div style={{ width: "100%" }}>
        <h3 className="text-center mb-2" id="signup-title">
          Sign Up
        </h3>

        {/* Success/Error Message */}
        {message.text && (
          <div
            className={`alert alert-${message.type}`}
            id={`signup-message-${message.type}`}
          >
            {message.text}
          </div>
        )}

        <Formik
          initialValues={{
            firstName: "",
            lastName: "",
            email: "",
            password: "",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form id="signup-form">
              {/* First Name */}
              <div className="mb-3">
                <label htmlFor="signup-first-name" className="form-label">
                  First Name *
                </label>
                <Field
                  type="text"
                  name="firstName"
                  id="signup-first-name"
                  className="form-control"
                  placeholder="Enter first name"
                />
                <ErrorMessage
                  name="firstName"
                  component="small"
                  className="text-danger d-block mt-1"
                  id="error-signup-first-name"
                />
              </div>

              {/* Last Name */}
              <div className="mb-3">
                <label htmlFor="signup-last-name" className="form-label">
                  Last Name *
                </label>
                <Field
                  type="text"
                  name="lastName"
                  id="signup-last-name"
                  className="form-control"
                  placeholder="Enter last name"
                />
                <ErrorMessage
                  name="lastName"
                  component="small"
                  className="text-danger d-block mt-1"
                  id="error-signup-last-name"
                />
              </div>

              {/* Email */}
              <div className="mb-3">
                <label htmlFor="signup-email" className="form-label">
                  Email Address *
                </label>
                <Field
                  type="email"
                  name="email"
                  id="signup-email"
                  className="form-control"
                  placeholder="Enter email"
                />
                <ErrorMessage
                  name="email"
                  component="small"
                  className="text-danger d-block mt-1"
                  id="error-signup-email"
                />
              </div>

              {/* Password */}
              <div className="mb-3">
                <label htmlFor="signup-password" className="form-label">
                  Password *
                </label>
                <Field
                  type="password"
                  name="password"
                  id="signup-password"
                  className="form-control"
                  placeholder="Enter password"
                />
                <ErrorMessage
                  name="password"
                  component="small"
                  className="text-danger d-block mt-1"
                  id="error-signup-password"
                />
              </div>

              {/* Submit Button */}
              <div className="d-grid">
                <button
                  type="submit"
                  className="btn btn-primary"
                  id="signup-submit-button"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Loading..." : "Sign Up"}
                </button>
              </div>
            </Form>
          )}
        </Formik>

        {/* Login Link */}
        <p className="mt-3 text-center">
          Already registered?{" "}
          <Link
            to="/sign-in"
            className="text-decoration-none"
            id="signup-login-link"
          >
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
};

export default SignUp;
